<template>
    <div class="layout-profile">
        <div class="card p-d-inline-block">
            <!-- <img src="assets/layout/images/logo.png" alt="" /> -->
            <img v-if="client.logo" class="client_logo" :src="client.logo.src" :alt="client.logo.name" width="140" />
            <i v-else class="pi pi-fw pi-user"></i>
        </div>
        <button class="layout-profile-link p-ai-end p-col-11 p-d-flex p-link p-mx-auto p-jc-center" @click="onClick">
            <span class="username p-text-truncate">{{ user.data.email }}</span>
            <i class="pi pi-fw pi-angle-right dropdown-icon" :class="{ 'expanded': expanded }"></i>
        </button>
        <transition name="layout-submenu-wrapper">
            <ul v-show="expanded">
                <!-- <li><button class="p-link"><i class="pi pi-fw pi-user"></i><span>Account</span></button></li>
                <li><button class="p-link"><i class="pi pi-fw pi-inbox"></i><span>Notifications</span><span class="menuitem-badge">2</span></button></li> -->
                <li><a href="/signout" class="logout p-link p-d-block p-p-2 p-text-center" @click="signOut"><i
                            class="pi pi-fw pi-power-off"></i><span>Logout</span></a>
                </li>
            </ul>
        </transition>
    </div>
</template>

<script>
import firebase from 'firebase/compat/app'
import { db } from '@/firebase';
import store from './stores/store.js';
import { mapGetters } from "vuex";


export default {
    data() {
        return {
            expanded: false
        }
    },
    computed: {
        // map `this.user` to `this.$store.getters.user`
        ...mapGetters({
            user: "user",
        }),
    },
    methods: {
        onClick(event) {
            this.expanded = !this.expanded;
            event.preventDefault();
        },
        signOut() {
            firebase
                .auth()
                .signOut()
                .then(() => {
                    store.dispatch("fetchUser", null);
                    this.$router.push({
                        name: "login"
                    });
                });
        }
    },
    firestore() {
        return {
            client: db.collection('clients').doc(this.user.data.client.key),
        }
    },
}
</script>

<style lang="scss" scoped>

.logout {
    color:#fff;
}

.dropdown-icon {
    transition: transform 0.3s;
    &.expanded {
        transform: rotateZ(90deg);
    }
}
</style>